import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { renderStyledElementStyles } from '../../helpers';
import { SiteBuilderModule, StyledSVGEmbed } from '../sharedComponents';
import { DefaultDisplayStyle } from './displayStyles';

const Wrapper = styled.div`
  position: relative;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.siteBuilderModules.columnTextModule)}

  ${({ theme, displayStyle }) =>
    renderStyledElementStyles(
      theme,
      theme.siteBuilderModules.columnTextModule.displayStyles[displayStyle],
    )}

  ${({ theme, visualStyle }) =>
    renderStyledElementStyles(
      theme,
      theme.siteBuilderModules.columnTextModule.visualStyles[visualStyle],
    )}
`;

const ColumnTextModule = (props) => {
  const {
    section: { style: visualStyle, columnStyle: displayStyle },
  } = props;

  const themeConfig = useContext(ThemeContext);

  const dStyles =
    themeConfig.siteBuilderModules.columnTextModule.displayStyles[displayStyle];
  const vStyles =
    themeConfig.siteBuilderModules.columnTextModule.visualStyles[visualStyle];
  const countConfig = dStyles.settings.columnCount;

  const { settings: { backgroundSVGConfig = {} } = {} } = vStyles;

  return (
    <SiteBuilderModule section={props.section}>
      <Wrapper displayStyle={displayStyle} visualStyle={visualStyle}>
        {backgroundSVGConfig.path && (
          <StyledSVGEmbed
            href={backgroundSVGConfig.path}
            colors={backgroundSVGConfig}
          />
        )}
        <DefaultDisplayStyle
          count={countConfig}
          section={props.section}
          dStyles={dStyles}
          vStyles={vStyles}
        />
      </Wrapper>
    </SiteBuilderModule>
  );
};

ColumnTextModule.propTypes = {
  section: PropTypes.shape({
    style: PropTypes.oneOf([
      'LIGHT',
      'DARK',
      'STANDARD_DARK',
      'STANDARD_LIGHT',
      'BRAND_LIGHT',
      'BRAND_DARK',
      'LARGE_DARK',
      'LARGE_LIGHT',
    ]).isRequired,
    columnStyle: PropTypes.oneOf([
      'TWO_COLUMNS',
      'THREE_COLUMNS',
      'FOUR_COLUMNS',
    ]).isRequired,
  }).isRequired,
};

export default ColumnTextModule;
